module.exports = __webpack_public_path__ + "static/media/add-photo.67ad8952.svg";